import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"

import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableAvisAbsence from "./DataTableAvisAbsence"
import AddAvisAbsence from "./AddAvisAbsence"
import DataTableAvisAbsenceValidation from "./DataTableAvisAbsenceValidation"
import DataTableRattrapageValidation from "./DataTableRattrapageValidation"
import DataTableAvisRattrapage from "../AvisRattrapage/DataTableAvisRattrapage"


const AvisAbsence = props => {
  var userAuthEnseignant = JSON.parse(
    localStorage.getItem("userAuthEnseignant")
  )
  var enseignant_id = userAuthEnseignant.user.enseignant_id
  var annee_id = userAuthEnseignant.user.annee_id
  var chef = userAuthEnseignant.user.chef
  const [section, setSection] = useState(1)

  const back = () => {
    setSection(1)
  }

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableAvisAbsence />
    } else if (section === 2) {
      return <AddAvisAbsence setSection={setSection} back={back} />
    }else if(section === 3 ){
      return <DataTableAvisAbsenceValidation />
    }else if(section === 4 ){
      return <DataTableRattrapageValidation />
    }else if(section === 5 ){
      return <DataTableAvisRattrapage />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Avis d'absence")}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1
                  })}
                  onClick={() => {
                    setSection(1)
                  }}
                >
                  {props.t("Avis d'absence")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >
                  {props.t("Ajouter avis d'absence")}
                </NavLink>
              </NavItem>
              {chef === 1 ? (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 3
                    })}
                    onClick={() => {
                      setSection(3)
                    }}
                  >
                    {props.t("Liste des avis d'absence des enseignants")}
                  </NavLink>
                </NavItem>
              ) : null}
              {chef === 1 ? (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: section === 4
                    })}
                    onClick={() => {
                      setSection(4)
                    }}
                  >
                    {props.t("Liste des rattrapages validés par les enseignants")}
                  </NavLink>
                </NavItem>
              ) : null}
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 5
                  })}
                  onClick={() => {
                    setSection(5)
                  }}
                >
                  {props.t("Liste de rattrapage ")}
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

AvisAbsence.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any
}

export default withRouter(withTranslation()(AvisAbsence))
